import axiosServices from './request';

const AudioBook = axiosServices('/audiobook/v1.0');

export default {
  /** 新增资源信息 */
  insertResource: AudioBook('post', 'yiListeningPdf/insertResource'),
  // 查询有声书的使用权限，返回有小睿币和使用时间
  getAiAudioPermission: AudioBook('get', 'aiAudio/getAiAudioPermission'),
  // 新建文件夹
  addFolder: AudioBook('post', 'folder/addFolder'),
  // 获取文件夹列表
  listFolder: AudioBook('get', 'folder/listFolder'),
  // 删除文件夹
  deleteFolders: AudioBook('post', 'folder/deleteFolders'),
  // 操作文件夹
  operateFolder: AudioBook('post', 'folder/operateFolder'),
  // 文件夹下获取音频
  listPageAiAudioRecordByFolderId: AudioBook('get', 'aiAudio/listPageAiAudioRecordByFolderId'),
  // 编辑文件夹
  editFolder: AudioBook('post', 'folder/editFolder'),
  // 根据文件夹ID获取文件夹下已合成记录ID接口
  getRecordListByFolderId: AudioBook('post', 'aiAudio/getRecordListByFolderId'),
  // 获取empid
  getEmployeeIdByAdviserIdAndJobId: AudioBook('get', 'aiAudio/getEmployeeIdByAdviserIdAndJobId'),
  // 提交批量下载
  submitBatchDownload: AudioBook('post', 'aiAudio/submitBatchDownload'),
  // 批量下载详情 GET https://audiobook.raysgo.com/audiobook/v1.0/aiAudio/fetchBatchDownload?requestId=ba0a8df2a9264727b1b828956a17cf1c
  fetchBatchDownload: AudioBook('get', 'aiAudio/fetchBatchDownload')

};
